"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputChangeHandle = exports.checkForm = exports.verifyValLength = exports.onlyInteger = exports.onlyPositiveInteger = exports.onlyChinese = exports.onlyNumber = exports.isNormalCharater = exports.isMobile = exports.isEmpty = exports.trim = void 0;
/**
 * 去除前后空格函数
 * @param {待去除空格的字符串} str
 */
var trim = function (str) {
    var reSpace = /^\s*(.*?)\s*$/;
    return str.toString().replace(reSpace, "$1");
};
exports.trim = trim;
/**
 * 验证str是否为空,可设置默认单位unit，会验证去除单位的字符串是否为空
 * @param {待校验字符串} str
 * @param {默认单位} unit
 * @return true 是空 false 非空
 */
var isEmpty = function (str, unit) {
    if (unit === void 0) { unit = ""; }
    var endIndex, result;
    if (unit) {
        endIndex = str.indexOf(unit);
        result = exports.trim(str.substr(0, endIndex));
    }
    else {
        result = exports.trim(str);
    }
    return !result;
};
exports.isEmpty = isEmpty;
/**
 * 验证str是不是手机号格式
 * @param {*待验证字符串} str
 * @return true是手机号格式 false非手机号格式
 */
var isMobile = function (str) {
    var reg = /^1[3|4|5|6|7|8|9][0-9][\d]{8}$/;
    return reg.test(str.toString());
};
exports.isMobile = isMobile;
// 验证str是否包含特殊字符
var isNormalCharater = function (str) {
    var reg = /[^a-zA-Z|\d|\u4e00-\u9fa5]/g;
    return !reg.test(str.toString());
};
exports.isNormalCharater = isNormalCharater;
var onlyNumber = function (str) {
    var reg = /^\d+(\.\d{1,2})?$/g;
    return reg.test(str.toString());
};
exports.onlyNumber = onlyNumber;
var onlyChinese = function (str) {
    var reg = /^[\u4e00-\u9fa5]+$/g;
    return reg.test(str.toString());
};
exports.onlyChinese = onlyChinese;
var onlyPositiveInteger = function (str) {
    var reg = /^(?:[1-9]\d*)$/g;
    return reg.test(str.toString());
};
exports.onlyPositiveInteger = onlyPositiveInteger;
var onlyInteger = function (str) {
    var reg = /^(?:\d+)$/g;
    return reg.test(str.toString());
};
exports.onlyInteger = onlyInteger;
/**
 * 验证内容长度
 * @param str 传入的内容
 * @param length 字符串最小的长度
 */
var verifyValLength = function (str, length) {
    if (length === void 0) { length = 5; }
    return str.toString().length > length;
};
exports.verifyValLength = verifyValLength;
/**
 * 针对formData进行校验
 * @param {待校验对象数组} formData
*  格式：[
        {
            id:'realname',// 必填
            value:'',//待验证字符串 必填
            rule:'',//验证规则  规则之间用,分割  empty/tel/realname/radio
            require:true,//是否必填 必填
        }
    ]
 *  @return {promise} 验证通过 resolve  验证失败 reject(id)
 
*/
var checkForm = function (formData) {
    var item, rules;
    return new Promise(function (resolve, reject) {
        if (formData === null || !Array.isArray(formData)) {
            reject();
        }
        else {
            for (var i = 0; i < formData.length; i++) {
                item = formData[i];
                rules = typeof item.rule == "string" ? item.rule.split(",") : [];
                if (((item.required || rules.indexOf("empty") != -1) &&
                    exports.isEmpty(item.value)) ||
                    (rules.indexOf("tel") != -1 && !exports.isMobile(item.value)) ||
                    (rules.indexOf("realname") != -1 && !exports.onlyChinese(item.value)) ||
                    (rules.indexOf("radio") != -1 && !item.value) ||
                    (rules.indexOf("length") != -1 && !exports.verifyValLength(item.value))) {
                    // 非空判断 || 手机号判断 || 真实姓名判断 只能是汉字 || radio是否选中
                    reject(item.id);
                    return false;
                }
            }
            resolve("success");
        }
    });
};
exports.checkForm = checkForm;
/**
 * input标签 onchange绑定事件
 * <input name="keyname" onChange={(event)=>{handleInputChange(event,that)} />
 * input内容改变 that.state[keyname].value也随着改变
 * @param {input标签绑定的事件event} event
 * @param {用与state赋值} that
 */
var InputChangeHandle = function (event) {
    // 更换数据
    var target = event.target, value = target.type === "checkbox" ? (target.checked ? 1 : -1) : target.value, name = target.name;
    return new Promise(function (resolve, reject) {
        resolve(value);
    });
};
exports.InputChangeHandle = InputChangeHandle;
